module.exports = __webpack_public_path__ + "static/media/s_16.8ebe2c6f.mp3";